export default __webpack_public_path__ + "static/media/edit-icon-white.b86cf944.svg";